export default __webpack_public_path__ + "static/media/dalenfireplace_thumb.676c98b9.jpg";